import React, { useEffect, useState } from 'react'
import { Navbar, Container, Nav, NavDropdown, Badge, } from 'react-bootstrap'
import { Link } from 'react-router-dom'
// import HamburgerComponent from './Hamburger'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBagShopping, } from '@fortawesome/free-solid-svg-icons'
import Search from './Search'
import { selectCart } from '../../../slice/itemSlice'
import { useSelector } from 'react-redux'

const NavbarComponent = () => {

  const cart = useSelector(selectCart)
  const [cartQuantity, setCartQuantity] = useState(0);

  useEffect(() => {
    if(Array.isArray(cart) && cart.length >= 0){
      let n = 0;
      cart.map(x => n += x.quantity)
      setCartQuantity(n)
    }
    // console.log("cart", cart)
  }, [cart, cartQuantity])

  return (
    <Navbar bg="light" expand="lg" sticky="top" >
      <Container fluid>
        <Link className='home-link text-decoration-none text-black-50 m-lg-3 m-md-2' to="/">Turquoise.</Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">

          <Nav className="ms-auto">

          <Link className='navbar-link mt-2 fs-5 mt-md-auto mb-auto p-2 text-black-50 text-decoration-none h-t-turquoise border-none' to="/sign-in">Sign-in</Link>
            <NavDropdown className='navbar-dropdown p-2 ' title="Categories" id="basic-nav-dropdown">
              <div className='d-flex flex-column'>

              {/* <NavDropdown.Item> */}
                <Link className='text-decoration-none text-black  mx-3 h-t-turquoise' to="/headphones">Headphones</Link>
              {/* </NavDropdown.Item> */}
              {/* <NavDropdown.Item> */}
                <Link className='text-decoration-none text-black  mx-3 h-t-turquoise' to="/keyboards">Keyboards</Link>
                {/* </NavDropdown.Item> */}
              {/* <NavDropdown.Item> */}
                <Link className='text-decoration-none text-black  mx-3 h-t-turquoise' to="/computers">Computers</Link>
                {/* </NavDropdown.Item> */}
              {/* <NavDropdown.Item> */}
                <Link className='text-decoration-none text-black  mx-3 h-t-turquoise' to="/phones">Phones</Link>
                {/* </NavDropdown.Item> */}
              {/* <NavDropdown.Item> */}
                <Link className='text-decoration-none text-black  mx-3 h-t-turquoise' to="/tables">Tables</Link>
              {/* </NavDropdown.Item> */}
              {/* <NavDropdown.Item> */}
                <Link className='text-decoration-none text-black  mx-3 h-t-turquoise' to="/chairs">Chairs</Link>
              {/* </NavDropdown.Item> */}
              {/* <NavDropdown.Item href="/headphones">Headphones</NavDropdown.Item> */}
              {/* <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item> */}
              </div>
            </NavDropdown>

            <Link className='navbar-link mt-auto mb-auto h-t-black p-2 text-black-50 text-decoration-none' to="/offers">Offers</Link>
            <Link className='navbar-link mt-auto mb-auto h-t-black p-2 text-black-50 text-decoration-none' to="/contact">Contact</Link>
            
            <Link className='ml-5 p-1 d-inline-flex p-2 text-turquoise hover-turquoise' to="/cart">

              {/* <p className='p-1 text-decoration-none'>Cart</p> */}
              <FontAwesomeIcon className='p-0 shopping-icon' icon={faBagShopping} /> 
              {/* <Badge pill className='mt-auto ' bg="light" text="dark" >{cartQuantity && cartQuantity}</Badge> */}
              <Badge pill className='mt-auto ' bg="light" text="dark" >{cartQuantity}</Badge>
            </Link>
          </Nav>
          <Search />
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default NavbarComponent